import React, { createContext, useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import LoginController from '../controller/LoginController';

export interface User {
  user_type: number;
  sales_id:number;
}
interface AuthContextType {
  user: User | null;
  login: (id: string, password: string) => any;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  login: () => false,
  logout: () => {},
});

const TemporaryUserInfo = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);

  const login = async (id: string, password: string): Promise<boolean> => {
    try {
      let oRes = await LoginController.signIn({ id, password });

      if (oRes.data && oRes.data.ok) {
        const oUserData = oRes.data.data;

        if (oUserData) {
          localStorage.setItem('user', JSON.stringify(oUserData));
          setUser(oUserData);
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logout = async () => {
    try {
      let oRes = await LoginController.logout();
      console.log('oRes>>', oRes);
      if (oRes.data && oRes.data.ok) {
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
    navigate('/login');
    setUser(null);
    localStorage.removeItem('user');
  };

  useEffect(() => {
    const UserData = localStorage.getItem('user');
    if (UserData) {
      try {
        const parsedUser: User = JSON.parse(UserData);
        setUser(parsedUser);
      } catch (error) {
        console.error('Failed to parse user data:', error);
      }
    }
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export default TemporaryUserInfo;
